import { routes as catalog } from './catalog/routes';
import { routes as contacts } from './contacts/routes';
import { routes as dataio } from './dataio/routes';
import { routes as foodpanda } from './foodpanda/routes';
import { routes as insights } from './insights/routes';
import { routes as inventory } from './inventory/routes';
import { routes as payments } from './payments/routes';
import { routes as purchases } from './purchases/routes';
import { routes as quotations } from './quotations/routes';
import { routes as returns } from './returns/routes';
import { routes as sales } from './sales/routes';
import { routes as shop } from './shop/routes';
import { routes as support } from './support/routes';
import type { FeatureRoute } from './types';

/** Every feature's routes. Each Phase 2 milestone owns one or more feature folders. */
export const featureRoutes: FeatureRoute[] = [
  ...shop,
  ...contacts,
  ...catalog,
  ...inventory,
  ...quotations,
  ...sales,
  ...purchases,
  ...payments,
  ...returns,
  ...insights,
  ...support,
  ...dataio,
  ...foodpanda,
];

const registered = new Set(featureRoutes.map((r) => `/${r.path.replace(/^\/+/, '')}`));

/** True when a screen exists for this nav path (otherwise the nav shows it as coming soon). */
export function hasScreen(path: string): boolean {
  return path === '/' || registered.has(path);
}
